<template>
  <div>
    <div class="email-node">
      <div class="mb-6">
        <gd-tabs
          :tabs="tabs"
          :currentTab="currentTab"
          :wrapper-class="'gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="'p-2 border-primary text-primary border-b-2 gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleTabChange"
        />
      </div>
      <div class="step3 mb-6" v-if="currentTab === 'settings'">
        <div class="flex flex-no-wrap flex-col">
          <div class="flex flex-col w-full">
            <label class="font-semibold text-base text-dark mb-2">
              {{ $t('frontend_groovemail_adminsetting_name') }}
            </label>
            <text-input
              variant="base"
              v-model="localModel.broadcast"
              :placeholder="$t('frontend_groovemail_adminsetting_name')"
              :validator="$v.localModel.broadcast"
            />
          </div>
        </div>
      </div>
      <!-- end 3rd step -->
      <div class="step4 mb-6" v-if="currentTab === 'settings'">
        <div class="flex flex-no-wrap w-full flex-col">
          <label class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_forms_step3_sender') }}
          </label>
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <!-- @change="updatedEmailSender()" -->
            <select
              class="
                w-full
                h-10
                rounded-lg
                text-sm
                border border-grey-200
                text-dark
                bg-white
                pl-3
                pr-7
                appearance-none
              "
              v-model="localModel.sender_id"
            >
              <option value="-1">
                {{ $t('frontend_groovemail_sequences_email_select_sender') }}
              </option>
              <option
                :key="sender.id"
                v-for="sender in this.senders"
                :value="sender.id"
                :data-name="sender.name"
              >
                {{ sender.name }}
              </option>
            </select>
          </div>

          <!-- Can mail/Upgraded user/Sandbox mode check -->
          <div
            v-if="this.userCanMail"
            class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
            @click="createNewEmailSender"
          >
            <PlusIcon class="h-5 w-5"/>
            <p>
              {{ $t('frontend_create') }}
              {{ $t('frontend_groovemail_settings_sender_settings') }}
            </p>
          </div>
          <!-- Can mail/Upgraded user/Sandbox mode check -->
        </div>
      </div>

      <div class="step7 mb-6">
        <div class="activeicon">
          <div class="flex flex-col">
            <div class="flex mb-6" v-if="currentTab === 'settings'">
              <div class="w-full">
                <div>
                  <div class="w-full">
                    <label
                      class="
                        flex
                        items-center
                        font-semibold
                        flex
                        text-base text-dark
                        mb-2
                      "
                    >
                      <span class="mr-1">
                        {{$t('frontend_groovemail_sequences_edit_subject') }}
                      </span>
                      <button
                        v-tooltip="{
                          content: $t(
                            'frontend_add_dynamic_variables_to_subject'
                          ),
                          placement: 'right-start',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 10,
                          delay: {
                            show: 200,
                            hide: 300,
                          },
                        }"
                      >
                        <InfoIcon class="text-grey-600 h-4 w-4"/>
                      </button>
                    </label>
                  </div>

                  <div class="w-full relative">
                    <text-input
                      variant="base"
                      v-model="localModel.subject"
                      :placeholder="$t('frontend_groovemail_sequences_edit_subject')"
                      :validator="$v.localModel.subject"
                    />
                    <div
                      v-click-outside="closeSubjectVariables"
                      class="plus-round-icon bg-primary absolute"
                      style="right: 8px; top: 8px"
                      @click="openSubjectVariables"
                    >
                      <div
                        class="
                          bg-white
                          btn-radius
                          py-6
                          pl-6
                          absolute
                          overflow-auto
                        "
                        style="
                          width: 290px;
                          right: -10px;
                          bottom: 35px;
                          z-index: 100;
                          box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                        "
                        v-if="showSubjectDropdown"
                      >
                        <div class="pr-6">
                          <text-input
                            variant="base"
                            v-model="emailSubjectVariableSearch"
                            @input="changedEmailSubjectSearchVariable"
                            :placeholder="$t('frontend_groovemail_tables_search_query')"
                          >
                            <SearchIcon slot="prependIcon"/>
                          </text-input>
                        </div>
                        <VuePerfectScrollbar>
                          <div
                            class="mt-6 text-sm font-semibold"
                            style="max-height: 160px"
                          >
                            <div
                              class="mb-6"
                              v-for="(
                                option, index
                              ) in dynamic_variables_sms_content_subject"
                              :key="index"
                            >
                              <div
                                class="cursor-pointer text-grey-700 text-left"
                                @click="copyVariableInSubject(option)"
                              >
                                {{ option.label }}
                              </div>
                            </div>
                          </div>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex" v-if="currentTab === 'settings'">
              <div class="w-full">
                <div class="flex flex-col">
                  <label class="font-semibold text-base text-dark mb-2">
                    {{ $t('frontend_groovemail_sequences_edit_preview') }}
                  </label>
                  <div class="w-full">
                    <text-input
                      variant="base"
                      v-model="localModel.previewtext"
                      :placeholder="$t('frontend_groovemail_sequences_edit_preview')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentTab === 'message'">
              <div class="flex flex-col my-6">
                <label class="font-semibold text-base mb-2">
                  {{ $t('frontend_groovemail_email_types_label') }}
                </label>
                <div class="flex">
                  <div
                    v-for="(option, index) in email_type_options"
                    :key="index"
                    class="w-1/3 campaign-radio"
                    :class="{
                      'pl-2': index !== 0,
                      'pr-2': index !== email_type_options.length - 1,
                    }"
                  >
                    <gd-custom-radio
                      v-model="localModel.editor_type"
                      class="bg-white border p-8 pb-2 text-center"
                      :option="option"
                      value="localModel.editor_type"
                    ></gd-custom-radio>
                  </div>
                </div>
              </div>

              <div>
                <div v-if="localModel.editor_type === 3 && showEmailComposers">
                  <div class="mb-2">
                    <label class="font-semibold text-base">
                      {{ $t('frontend_groovemail_campain_message') }}
                    </label>
                  </div>
                  <div
                    class="mb-2"
                    style="width: 400px"
                    v-if="this.localModel.template_name"
                  >
                    <label class="font-semibold text-base">
                      {{ $t('frontend_groovemail_email_builder_past_template_email_name') }}
                      : {{ this.localModel.template_name }}
                    </label>
                  </div>
                  <div class="flex justify-between">
                    <gd-button
                      size="expand"
                      variant="primary"
                      @click="openEmailBuilder"
                    >
                      {{ $t('frontend_groovemail_email_builder_compose_your_email') }}
                    </gd-button>
                    <gd-button
                      size="md"
                      class="ml-4"
                      :class="{
                        'cursor-not-allowed disabled-preview':
                          !localModel.content,
                      }"
                      @click="
                        localModel.content ? openCreateEmailPreview() : null
                      "
                    >
                      <PreviewIcon class="h-5 w-5"/>
                    </gd-button>
                  </div>
                </div>
                <div v-if="localModel.editor_type !== 3 && showEmailComposers">
                  <email-basic-editor
                    :key="1"
                    ref="sequence-add-email-editor"
                    :editorOptions="sequenceEditorOptions"
                    :editorContent="localModel.content"
                    :editorNodeWithNoMargin="true"
                    :editorWithBlockedLinkRestriction="true"
                    :editorDynamicVariables="builderVariables"
                    openedFrom="sequence-add"
                    :allowEditorPreview="true"
                    :allowEditorHtmlView="false"
                    :currentEditorView="localModel.editor_type"
                    @editorContentUpdated="localModel.content = $event"
                    @templateSelected="localModel.subject = $event.subject; localModel.previewtext = $event.previewText"
                  ></email-basic-editor>
                </div>

                <div
                  class="text-left pt-4"
                  v-if="checkValidEmailContent() && isEmailContentSubmitted"
                >
                  <p class="text-sm text-danger">
                    {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_email_content_empty') }}
                  </p>
                </div>
              </div>
              <div class="mt-4">
                <SendTestEmail
                  ref="sendCreateSeqTestMail"
                  @showLoader="showLoader"
                  @hideLoader="hideLoader"
                  @proceeedSendingTestEmail="proceeedSendingTestEmail"
                ></SendTestEmail>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end step 7 -->
    </div>

    <!-- Email builder modal -->
    <portal to="modalsTarget">
      <slide-over
        id="generic-email-builder-modal"
        bgColor="white"
        width="full"
        animation="slideup"
        name="generic-email-builder-modal-sequence-create"
        @collapse="openEmailChangeLostConfirm('email')"
      >
        <email-builder
          ref="sequence-create-email-builder"
          :emailTemplateId="emailTemplateId"
          :templateId="template_id"
          :emailMeta="getEmailMetaData"
          :openedFrom="'sequence'"
          :openedType="localModel.email_id ? 'edit' : 'add'"
          :templateType="templateType"
          :builderVariables="builderVariables"
          :blockedLinkRestriction="true"
          :showResetTemplate="true"
          :allowSaveRows="true"
          @saveEmailTemplateContent="saveContentWithMeta"
          @changeCurrentTemplate="openEmailChangeLostConfirm('template')"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
        ></email-builder>
      </slide-over>
      
      <gd-modal
        id="show-emailpreview-modal"
        width="80%"
        height="100%"
        name="open-sequence-create-preview-modal"
        :title="$t('frontend_preview')"
      >
        <VuePerfectScrollbar>
          <div class="w-full p-6" style="height: calc(100vh - 115px)">
            <div>
              <div
                class="pb-6"
                v-html="
                  localModel.content +
                  `<p style='margin: 0px'><br></p>` +
                  unsubscribeContent
                "
              ></div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </gd-modal>
  
      <gd-modal
        name="create-sequence-email-templates-modal"
        class="gm-befree-email-templates-modal"
        :title="$t('frontend_groovemail_modal_email_template_header')"
        width="95vw"
        height="95vh"
      >
        <div
          class="w-full py-4"
          style="max-height: calc(100vh - 90px); min-height: 70vh"
        >
          <template-container
            filtersHeight="calc(100vh - 260px)"
            templatesHeight="calc(100vh - 120px)"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @selectedTemplate="selectThisTemplate"
          ></template-container>
        </div>
      </gd-modal>
  
      <!-- Confirmation email change lost modal -->
      <confirm-modal
        :ref="`confirmation-email-change-lost`"
        :name="`confirmation-email-change-lost`"
        :buttonText="$t('frontend_confirm')"
        :cancelText="$t('frontend_cancel')"
        :hideClose="true"
        :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
        :messageContent="confirmMessage"
        @confirm="emailChangeLostConfirm"
      />
    </portal>
    
    <!-- Confirmation editor type change modal -->
    <confirm-modal
      :ref="`confirmation-editor-type`"
      :name="`confirmation-editor-type`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :hideClose="true"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_email_type_change_warning')"
      @confirm="confirmEditorTypeChange"
      @close="closeConfirmEditorTypeChange"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ClickOutside from 'vue-click-outside';
import SlideOver from '@/components/SlideOver.vue';
import EmailBuilder from '@/components/befree-email-builder/builder.vue';
import EmailBasicEditor from '@/components/EmailBasicEditor.vue';
import { syncEditorContent } from '@/components/emailContentValidation';
import TemplateContainer from '@/components/befree-email-builder/template-container.vue';
import SendTestEmail from '@/components/send-test-email';
import themeConfig from '@/theme/themeConfig';

import showAlert from '@/components/sweet-alert-popup.js';

// import icon
import InfoIcon from '@/assets/images/icons/new/info_new.svg';
import PreviewIcon from '@/assets/images/icons/new/preview_new.svg';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';
import SearchIcon from '@/assets/images/icons/new/search_new.svg';

export default {
  name: 'EmailNode',
  props: {
    model: {
      required: true,
    },
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      editorTypeChangedInternally: false,
      showEmailComposers: true,
      isEmailContentSubmitted: false,
      currentTab: 'settings',
      verifiedSendersRequired: false,
      localModel: this.model,
      senders: [],
      mainselect: '',
      mainselectname: '',
      assignrecipient: '',
      assignrecipientname: '',
      showSubjectDropdown: false,
      emailSubjectVariableSearch: '',
      unsubscribeContent: '',
      sequenceEditorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              [{ list: 'ordered' }, { list: 'bullet' }],

              ['link', 'image'],
              [{ size: ['10px', false, '18px', '32px'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ align: [] }],
            ],
            handlers: {
              image: () => this.handleImageInsertionInContent(),
            },
          },
        },
      },
      dynamic_variables_sms_content_subject: [],
      dynamic_variables_sms_subject: [
        {
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
      ],
      builderVariables: [
        {
          name: this.$t('frontend_groovemail_contacts_step2_first_name'),
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          name: this.$t('frontend_groovemail_contacts_step2_last_name'),
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          name: this.$t('frontend_groovemail_email_show_email'),
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          name: this.$t('frontend_groovemail_email_show_phone'),
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_company'),
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_city'),
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_state'),
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_country'),
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_url'),
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_billing'),
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          name: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
      ],
      emailTemplateId: '',
      templateType: '',
      template_id: null,

      newEmailType: null,
      oldEmailType: null,
      confirmMessage: '',
      confirmTarget: '',
    };
  },

  validations: {
    localModel: {
      broadcast: {
        required,
      },
      subject: {
        required,
      },
      content: {
        required,
      },
    },
  },

  computed: {
    //  Can mail/Upgraded user/Sandbox mode check
    userCanMail() {
      return this.getCanMail();
    },
    //  Can mail/Upgraded user/Sandbox mode check

    tabs() {
      return [
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_user_index_settings'
          )}</span>`,
          value: 'settings',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_sequences_edit_message'
          )}</span>`,
          value: 'message',
        },
      ];
    },

    mainTabClass: () => 'pb-4 gs-default-tabs-item',

    getEmailMetaData() {
      return {
        emailId: this.localModel.email_id,
        templateName: this.localModel.template_name,
        templateFolder: this.localModel.template_folder,
      };
    },

    email_type_options() {
      return [
        {
          id: 3,
          title: this.$t('frontend_groovemail_email_type_email_builder_text'),
          description: this.$t(
            'frontend_groovemail_email_type_email_builder_description'
          ),
          placeholder: '',
        },
        {
          id: 1,
          title: this.$t('frontend_groovemail_email_type_basic_editor_text'),
          description: this.$t(
            'frontend_groovemail_email_type_basic_editor_description'
          ),
          placeholder: '',
        },
        {
          id: 2,
          title: this.$t('frontend_groovemail_email_type_html_paste_text'),
          description: this.$t(
            'frontend_groovemail_email_type_html_paste_description'
          ),
          placeholder: '',
        },
      ];
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'localModel.editor_type': async function handleEmailTypeChange(newEmailType, oldEmailType) {
      if (this.editorTypeChangedInternally) {
        this.editorTypeChangedInternally = false;
      } else if (
        (((newEmailType === 1 || newEmailType === 2) && oldEmailType === 3) ||
          newEmailType === 3) && this.localModel.content
      ) {
        this.showEmailComposers = false;
        
        // open confirmation editor type
        this.openEditorTypeConfirmation(newEmailType, oldEmailType);
      } else if (newEmailType === 2 && oldEmailType === 1) {
        this.validateEmailContent();
      }
    },
  },

  async created() {
    await this.fetchSendersData();
    await this.fetchsenders();
    await this.fetchCustomFieldVariable();
    this.dynamic_variables_sms_content_subject =
      this.dynamic_variables_sms_subject;
    if (!this.localModel.content) {
      this.localModel.content = '';
    }
    if (this.localModel.email_id) {
      this.emailTemplateId = this.localModel.email_id;
      this.templateType = 'user-email';
    }
    // await this.updatedEmailSender();
  },

  methods: {
    // Can mail/Upgraded user/Sandbox mode check
    ...mapGetters('mailing', ['getCanMail']),
    // Can mail/Upgraded user/Sandbox mode check

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    handleImageInsertionInContent() {
      this.$refs['sequence-add-email-editor'].handleImageInsertionInContent();
    },

    initializeEmailContentData() {
      this.localModel.content = '';
      this.localModel.emailContentSections = '';
      this.localModel.email_id = null;
      this.localModel.template_name = '';
      this.localModel.template_folder = null;
    },

    // open confirmation chnage email type modal
    openEditorTypeConfirmation(newEmailType, oldEmailType) {
      // set new and old email type
      this.newEmailType = newEmailType;
      this.oldEmailType = oldEmailType;

      // open confirmation editor type
      this.$refs[`confirmation-editor-type`].open();
    },

    // confirm editor type chnage
    confirmEditorTypeChange() {
      this.localModel.editor_type = this.newEmailType;
      this.editorTypeChangedInternally = true;
      this.initializeEmailContentData();

      this.showEmailComposers = true;
    },

    // close confirmation editor type
    closeConfirmEditorTypeChange() {
      // reset new and old email type
      this.localModel.editor_type = this.oldEmailType;
      this.editorTypeChangedInternally = true;

      this.showEmailComposers = true;

      // reset new and old email type
      this.newEmailType = null;
      this.oldEmailType = null;
    },

    checkValidEmailContent() {
      let validEmailContent = false;
      if (
        this.localModel.editor_type === 1 ||
        this.localModel.editor_type === 2
      ) {
        if (this.localModel.content) {
          validEmailContent = true;
        }
      } else if (
        this.localModel.content ||
        this.localModel.emailContentSections
      ) {
        validEmailContent = true;
      }
      return !validEmailContent;
    },

    validateEmailContent() {
      const editor = this.$refs ? this.$refs['sequence-add-email-editor'] : null;
      syncEditorContent(editor, (html) => {
        this.localModel.content = html;
      });
    },

    // open emailChangeLostConfirm modal
    openEmailChangeLostConfirm(option) {
      // set the confirmTarget
      this.confirmTarget = option;

      if (option === 'email') {
        
        // check change in content of email builder
        const changeInContent = this.$refs['sequence-create-email-builder'].checkChangeInContent();
        if (changeInContent) {
          // set the confirmMessage and confirmTarget
          this.confirmMessage = this.$t('frontend_groovemail_email_builder_content_will_be_lost');
       
          // open confirmation email chnage lost modal
          this.$refs[`confirmation-email-change-lost`].open();
        } else {
          this.closeBefreeBuilderSlider();
        }
        this.template_id = null;
      } else if (option === 'template') {
        this.confirmMessage = this.$t('frontend_groovemail_befree_email_builder_change_template_warning');

        // open confirmation chnage tamplate lost data modal
        this.$refs[`confirmation-email-change-lost`].open();
      }
    },

     // confirm email chnage lost modal
     async emailChangeLostConfirm() {
      if(this.confirmTarget === 'email') {
        this.closeBefreeBuilderSlider();

        this.template_id = null;
      } else if (this.confirmTarget === 'template') {
        this.closeBefreeBuilderSlider();
        this.initializeEmailContentData();
        // if (this.localModel.email_id) {
        //   this.initializeEmailContentData();
        //   // this.$emit('saveOnEmailContentReset'); // save after reset
        // } else {
        //   this.initializeEmailContentData();
        // }
        this.$root.$emit('modal-open', 'create-sequence-email-templates-modal');
      }

      // reset the confirmMessage and confirmTarget
      this.confirmTarget = '';
      this.confirmMessage = '';
    },

    openBefreeBuilderSlider() {
      this.$root.$emit('expand-slider', 'generic-email-builder-modal-sequence-create');
    },

    closeBefreeBuilderSlider() {
      this.$root.$emit('collapse-slider', 'generic-email-builder-modal-sequence-create');
    },

    async openCreateEmailPreview() {
      this.showLoader();
      try {
        const unsubscribeData = await axios.get(
          '/setting/get-unsubscribe-layout'
        );
        this.unsubscribeContent = unsubscribeData.data.footer_layout;
        this.hideLoader();
      } catch (e) {
        this.hideLoader();
      }
      this.$root.$emit('modal-open', 'open-sequence-create-preview-modal');
    },

    async openEmailBuilder() {
      if (this.localModel.email_id || this.localModel.content) {
        this.openBefreeBuilderSlider();
      } else {
        this.$root.$emit('modal-open', 'create-sequence-email-templates-modal');
      }
    },

    async selectThisTemplate(templateId, templateType) {
      if (templateId) {
        this.emailTemplateId = templateId;
      }
      this.templateType = templateType || 'template';
      this.$root.$emit('modal-close', 'create-sequence-email-templates-modal');
      this.openBefreeBuilderSlider();
    },

    saveContentWithMeta(saveAs, emailJson, htmlData, emailTemplateMeta) {
      if (saveAs === 1 || saveAs === 3) {
        this.saveEmailContent(emailJson, htmlData, emailTemplateMeta, saveAs);
      } else if (saveAs === 2) {
        this.saveTemplateContent(emailJson, htmlData, emailTemplateMeta);
      }
    },

    async saveEmailContent(emailJson, htmlData, emailTemplateMeta, saveAs) {
      this.localModel.content = htmlData;
      this.localModel.emailContentSections = emailJson;
      if (emailTemplateMeta) {
        this.localModel.template_name = emailTemplateMeta.templateName;
        this.localModel.template_folder = emailTemplateMeta.templateFolder;
      }
      if (this.localModel.email_id) {
        try {
          this.showLoader();
          const emailPayload = this.fetchEmailPayload(
            emailJson,
            htmlData,
            emailTemplateMeta
          );
          await axios.put(
            `/email/template/${this.localModel.email_id}`,
            emailPayload
          );
          if (saveAs === 3) {
            this.closeBefreeBuilderSlider();
            this.template_id = null;
          }
          this.hideLoader();
        } catch (e) {
          this.showErrorMessage('frontend_groovemail_email_builder_templates_saving_retry');
          this.hideLoader();
        }
      } else {
        try {
          this.showLoader();
          const emailPayload = this.fetchEmailPayload(
            emailJson,
            htmlData,
            emailTemplateMeta
          );
          const emailSaveRes = await axios.post(
            `/email/template/create`,
            emailPayload
          );
          this.localModel.email_id = emailSaveRes?.data?.id
            ? emailSaveRes?.data?.id
            : null;
          this.emailTemplateId = this.localModel.email_id;
          this.templateType = 'user-email';
          if (saveAs === 3) {
            this.closeBefreeBuilderSlider();
            this.template_id = null;
          }
          this.hideLoader();
        } catch (e) {
          this.showErrorMessage('frontend_groovemail_email_builder_templates_saving_retry');
          this.hideLoader();
        }
      }
    },

    fetchEmailPayload(jsonData, htmlData, templateMeta) {
      return {
        message: htmlData,
        template_name: templateMeta.templateName,
        category_id: templateMeta.templateFolder,
        emailContentSections: jsonData,
        screenshot_image: templateMeta.screenshot
          ? templateMeta.screenshot
          : '',
      };
    },

    async saveTemplateContent(emailJson, htmlData, emailTemplateMeta) {
      if (emailTemplateMeta.templateId) {
        await this.updateTemplateContent(
          emailJson,
          htmlData,
          emailTemplateMeta
        );
      } else {
        await this.saveNewTemplateContent(
          emailJson,
          htmlData,
          emailTemplateMeta
        );
      }
    },

    fetchTemplatePayload(jsonData, htmlData, templateMeta) {
      return {
        template_name: templateMeta.templateName,
        category_id: templateMeta.templateFolder,
        emailContentSections: jsonData,
        message: htmlData,
        screenshot_image: templateMeta.screenshot
          ? templateMeta.screenshot
          : '',
      };
    },

    async saveNewTemplateContent(jsonData, htmlData, templateMeta) {
      try {
        this.showLoader();
        const templatePayload = this.fetchTemplatePayload(
          jsonData,
          htmlData,
          templateMeta
        );
        const templateSaveRes = await axios.post(
          `/user/template/create`,
          templatePayload
        );
        this.template_id = templateSaveRes?.data?.id
          ? templateSaveRes?.data?.id
          : null;
        this.hideLoader();
      } catch (e) {
        this.showErrorMessage('frontend_groovemail_email_builder_templates_saving_retry');
        this.hideLoader();
      }
    },

    async updateTemplateContent(jsonData, htmlData, templateMeta) {
      try {
        this.showLoader();
        const templatePayload = this.fetchTemplatePayload(
          jsonData,
          htmlData,
          templateMeta
        );
        const templateSaveRes = await axios.put(
          `/user/template/${this.template_id}`,
          templatePayload
        );
        this.template_id = templateSaveRes?.data?.id
          ? templateSaveRes?.data?.id
          : null;
        this.hideLoader();
      } catch (e) {
        this.showErrorMessage('frontend_groovemail_email_builder_templates_saving_retry');
        this.hideLoader();
      }
    },

    createNewEmailSender() {
      this.$emit('createNewEmailSender', 2);
    },

    async updateEmailSenderData(senderData) {
      await this.fetchsenders();
      if (!this.verifiedSendersRequired && senderData && senderData.id) {
        this.localModel.sender_id = senderData.id;
      }
    },

    closeSubjectVariables() {
      this.showSubjectDropdown = false;
    },

    openSubjectVariables() {
      this.showSubjectDropdown = true;
    },

    changedEmailSubjectSearchVariable(searchQuery) {
      if (searchQuery) {
        this.dynamic_variables_sms_content_subject =
          this.dynamic_variables_sms_subject.filter((ele) =>
            ele.label.toLowerCase().includes(searchQuery.toLowerCase())
          );
      } else {
        this.dynamic_variables_sms_content_subject =
          this.dynamic_variables_sms_subject;
      }
    },

    copyVariableInSubject(option) {
      if (!this.localModel.subject) {
        this.localModel.subject = '';
      }
      this.localModel.subject += `${option.value}`;
      this.showSubjectDropdown = false;
      this.emailSubjectVariableSearch = '';
      this.dynamic_variables_sms_content_subject =
        this.dynamic_variables_sms_subject;
    },

    handleTabChange(newTab) {
      this.currentTab = newTab;
    },

    async fetchSendersData() {
      const sendersData = await axios.get('/email-sms-sender');
      if (sendersData.data.admin_setting) {
        this.verifiedSendersRequired = true;
      } else {
        this.verifiedSendersRequired = false;
      }
    },

    async fetchCustomFieldVariable() {
      try {
        const customFieldsData = await axios.post('/customfield-variables');
        customFieldsData.data.forEach((fieldData) => {
          this.dynamic_variables_sms_subject.push(fieldData);
          const mergeTagData = fieldData;
          mergeTagData.name = mergeTagData.label;
          this.builderVariables.push(mergeTagData);
        });
      } catch (e) {
        console.log(e);
      }
    },

    deleterecipient(option) {
      const index = this.localModel.emailassigned.indexOf(option);
      this.localModel.emailassigned.splice(index, 1);
    },

    validate() {
      if (this.localModel.editor_type === 1 || this.localModel.editor_type === 2) {
        this.validateEmailContent();
      }
      this.$v.$touch();
      this.isEmailContentSubmitted = true;
      const isValid =
        !this.$v.$invalid &&
        (this.localModel.editor_type === 1 ||
          this.localModel.editor_type === 2 ||
          this.localModel.emailContentSections);
      this.$emit('on-validate', isValid);
      if (
        !this.localModel.sender_id ||
        this.localModel.sender_id === -1 ||
        this.$v.localModel.broadcast.$invalid ||
        this.$v.localModel.subject.$invalid
      ) {
        this.currentTab = 'settings';
      } else if (
        ((this.localModel.editor_type === 1 ||
          this.localModel.editor_type === 2) &&
          this.$v.localModel.content.$invalid) ||
        (this.localModel.editor_type === 3 &&
          (this.$v.localModel.content.$invalid ||
            !this.localModel.emailContentSections))
      ) {
        this.currentTab = 'message';
      }
      return isValid;
    },

    changeSelect(e) {
      this.mainselectname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
    },

    async fetchsenders() {
      if (this.verifiedSendersRequired) {
        const { data } = await axios.get('/sender', {
          params: { verify: 1 },
        });
        if (data.length > 0) {
          this.senders = data;
        }
      } else {
        const { data } = await axios.get('/sender');
        if (data.length > 0) {
          this.senders = data;
        }
      }
      for (let i = 0; i < this.senders.length; i += 1) {
        if (this.senders[i].is_default === 1) {
          this.localModel.sender_id = this.senders[i].id;
        }
      }
    },

    async proceeedSendingTestEmail() {
      if (
        this.localModel.sender_id &&
        this.localModel.sender_id !== -1 &&
        !this.$v.localModel.subject.$invalid &&
        !this.$v.localModel.content.$invalid
      ) {
        await this.$refs.sendCreateSeqTestMail.sendTestEmail(
          this.localModel.sender_id,
          this.localModel.subject,
          this.localModel.previewtext,
          this.localModel.content
        );
      } else if (
        !this.localModel.sender_id ||
        this.localModel.sender_id === -1
      ) {
        this.showErrorMessage(
          'frontend_groovemail_send_test_email_sender_id_error'
        );
      } else if (this.$v.localModel.subject.$invalid) {
        this.showErrorMessage(
          'frontend_groovemail_send_test_email_subject_error'
        );
      } else if (this.$v.localModel.content.$invalid) {
        this.showErrorMessage(
          'frontend_groovemail_send_test_email_content_error'
        );
      } else {
        this.showErrorMessage('frontend_error');
      }
    },

    showErrorMessage(errorMessage) {
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark"> ${this.$t(errorMessage)}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },
  },

  components: {
    InfoIcon,
    VuePerfectScrollbar,
    EmailBuilder,
    SlideOver,
    TemplateContainer,
    EmailBasicEditor,
    SendTestEmail,
    PreviewIcon,
    PlusIcon,
    DownIcon,
    SearchIcon,
  },
};
</script>
